import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

function renderIframeViewerEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">iFrame Settings</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          URL to Embed
          <input
            type="text"
            value={(control.config?.src as string) || ''}
            onChange={(e) => onConfigChange('src', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://..."
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          iFrame Title
          <input
            type="text"
            value={(control.config?.title as string) || ''}
            onChange={(e) => onConfigChange('title', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="Title for accessibility"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Height (px)
          <input
            type="number"
            min="100"
            value={(control.config?.height as number) ?? 400}
            onChange={(e) => onConfigChange('height', e.target.value ? parseInt(e.target.value, 10) : 400)}
            className="af-properties-tab__input"
            placeholder="400"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label af-properties-tab__label--checkbox">
          <input
            type="checkbox"
            checked={(control.config?.sandbox as boolean) ?? true}
            onChange={(e) => onConfigChange('sandbox', e.target.checked)}
            className="af-properties-tab__checkbox"
          />
          Sandboxed (restricts scripts)
        </label>
      </div>
    </div>
  );
}

export const IframeViewerEditor: PropertyEditor = {
  type: 'iframe-viewer',
  label: 'Iframe Viewer',
  description: 'Configure iframe URL, title, height, and sandbox mode',
  render: renderIframeViewerEditor,
};
